import { REDUX_STATUS } from '@gymaholic/packages'
import { getObjectUtil } from 'packages/src'

/**
 * Checks whether the given instance is saving.
 * @param   {Instance} instance
 * @returns {boolean}
 */
function hasSuccessStatusReduxUtil (instance) {
  return getObjectUtil(instance, 'status') === REDUX_STATUS.SUCCESS
}

export default hasSuccessStatusReduxUtil
